export var IS_STAGING = false;

export function DebugError(...args) {
  if (IS_STAGING) {
    // eslint-disable-next-line
    console.error(...args);
  }
}

export function DebugLog(...args) {
  if (IS_STAGING) {
    // eslint-disable-next-line
    console.log(...args);
  }
}

export function SetStaging(isStaging) {
  IS_STAGING = isStaging;
}
